import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './redux/store';
import LaunchDarklyProvider from './launchdarkly/provider';
import { initLDDebugTools } from './launchdarkly';

// Import font styles
import './styles/fonts.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ColorModeScript />
    <Provider store={store}>
      <LaunchDarklyProvider>
        <App />
      </LaunchDarklyProvider>
    </Provider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Initialize LaunchDarkly debug tools as a fallback
// This ensures the debug functions are available even if the provider initialization fails
if (typeof window !== 'undefined') {
  // Expose the initialization function globally
  window.initLDDebugTools = initLDDebugTools;

  // Wait for the app to fully load before initializing debug tools
  window.addEventListener('load', () => {
    // Only initialize if not already initialized by the provider
    if (!window.listAllFlags) {
      initLDDebugTools();

      // Set up a fallback timer to check again after a few seconds
      setTimeout(() => {
        if (!window.ldClient) {
          initLDDebugTools();
        }
      }, 5000);
    }
  });

  // Add a global function to manually initialize debug tools
  window.initializeLDDebug = () => {
    initLDDebugTools();
    return 'LaunchDarkly debug tools initialized. Try window.listAllFlags() now.';
  };
}
